import React from 'react'
import MuiDialog from '@material-ui/core/Dialog'
import { withStyles } from '@material-ui/core/styles'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator'
import { validEmail } from '../../shared/validation'

import styles from './styles.js'

const Dialog = withStyles(() => ({
  paper: styles.dialog,
}))(MuiDialog)

const EmailDialog = ({
  error = false,
  required = true,
  helperText = '',
  isOpen = false,
  isLoading = false,
  onChange,
  onClose,
  title = 'Send Email',
  contentText = '',
  onSend,
  onCancel,
  leftButtonLabel = 'Cancel',
  rightButtonLabel = 'Send',
  closeButtonLabel = 'Ok',
  cypress_id,
  succeed = false,
  value,
}) => {
  const onInputChange = value => {
    let error = ''

    if (value.trim()) {
      const errorMessage = validEmail(value, 'Email is not valid')
      if (errorMessage) {
        error = errorMessage
      } else {
        error = ''
      }
    } else {
      error = 'Email value is required'
    }

    onChange(value, error)
  }

  return (
    <Dialog open={isOpen} onClose={onClose} disableEnforceFocus={true}>
      <DialogTitle cypress_id={`${cypress_id}-title`}>{title}</DialogTitle>
      <DialogContent>
        {isLoading ? (
          <LoadingIndicator label="Loading" />
        ) : (
          <React.Fragment>
            <DialogContentText cypress_id={`${cypress_id}-text`}>
              {contentText}
            </DialogContentText>
            <TextField
              autoFocus
              error={error}
              helperText={helperText}
              cypress_id={`${cypress_id}-email-text-field`}
              margin="dense"
              label="Email Address"
              type="email"
              fullWidth
              onChange={event => onInputChange(event.target.value)}
              value={value}
              variant="standard"
            />
          </React.Fragment>
        )}
      </DialogContent>
      <DialogActions>
        {!succeed && onCancel && (
          <Button
            disabled={isLoading}
            onClick={onCancel}
            color="primary"
            cypress_id={`${cypress_id}-cancel-button`}
          >
            {leftButtonLabel}
          </Button>
        )}
        {!succeed && onSend && (
          <Button
            disabled={
              isLoading || Boolean(error) || (required && !Boolean(value))
            }
            onClick={onSend}
            color="primary"
            autoFocus
            cypress_id={`${cypress_id}-send-button`}
          >
            {rightButtonLabel}
          </Button>
        )}
        {succeed && onClose && (
          <Button
            disabled={isLoading}
            onClick={onClose}
            color="primary"
            cypress_id={`${cypress_id}-close-button`}
          >
            {closeButtonLabel}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

export { EmailDialog }
